export default __webpack_public_path__ + "static/media/AddToPipeline.d8e2f743.png";